/* NOT: docs/assets/mqle-reviews.js.md — gerekceler ve gecmis orada */
(() => {
  'use strict';

  const READY = 'data-mqle-ready';


  const absolutise = (next, seed) => {
    if (/^https?:\/\//i.test(next)) return next;
    const seg = next.split('?')[0].split('/').filter(Boolean)[0];
    const cut = seg ? seed.indexOf('/' + seg + '/') : -1;
    let base = cut > -1 ? seed.slice(0, cut) : '';
    if (!base) {
      try { base = new URL(seed).origin; } catch (e) { return ''; }
    }
    return base + (next.charAt(0) === '/' ? next : '/' + next);
  };

  const readJSON = (root) => {
    const tpl = root.querySelector('[data-mqle-oke-src]');
    const node = tpl && tpl.content.querySelector('[data-oke-metafield-data]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (e) {
      return null;
    }
  };


  const fmt = (pattern, n) => (pattern || '').replace('%C', n);

  const monthYear = (iso) => {
    const d = new Date(iso);
    if (isNaN(d)) return '';
    try {
      return new Intl.DateTimeFormat('tr-TR', { month: 'long', year: 'numeric' }).format(d);
    } catch (e) {
      return '';
    }
  };

  const fillSummary = (root, agg) => {
    const total = agg.reviewCount || 0;
    if (!total) return;

    const dist = root.querySelector('[data-mqle-dist]');
    if (dist) {
      const byLevel = agg.reviewCountByLevel || {};
      const pattern = root.dataset.levelLabel || '';
      dist.querySelectorAll('[data-level]').forEach((row) => {
        const level = row.dataset.level;

        const n = byLevel['level' + level + 'Count'] || 0;
        row.querySelector('[data-mqle-dist-fill]').style.width = Math.round((n / total) * 100) + '%';
        row.querySelector('[data-mqle-dist-count]').textContent = n;
        row.querySelector('[data-mqle-dist-label]').textContent = pattern
          .replace('%L', level)
          .replace('%C', n);
      });
      dist.classList.add('is-ready');
    }

    const rec = root.querySelector('[data-mqle-rec]');
    if (rec && typeof agg.recommendationCount === 'number') {
      rec.querySelector('[data-mqle-rec-value]').textContent =
        '%' + Math.round((agg.recommendationCount / total) * 100);
      rec.classList.add('is-ready');
    }
  };


  /* Okendo medya anahtarlari, CDN d= davranisi, boyut merdiveni: docs/assets/mqle-reviews.js.md (28 Agu 2026) */
  const THUMB_KEYS = ['thumbnailUrl', 'largePortraitThumbnailUrl', 'largeUrl', 'url', 'mediaUrl', 'src'];
  const FULL_KEYS = ['largeUrl', 'fullSizeUrl', 'largePortraitThumbnailUrl', 'url', 'mediaUrl', 'src', 'thumbnailUrl'];
  const ZOOM_LADDER = [540, 720, 1080, 1200, 1600];
  const mediaUrl = (item, keys) => {
    if (!item) return '';
    for (let i = 0; i < keys.length; i += 1) {
      const v = item[keys[i]];
      if (typeof v === 'string' && v) return v;
    }
    return '';
  };
  const zoomUrl = (full) => {
    if (!/[?&]d=\d+x\d+/.test(full)) return full;
    const cap = window.innerWidth <= 820 ? 1200 : 1600;
    const need = Math.ceil(Math.min(window.innerWidth, window.innerHeight, 1200) * 0.92 * (window.devicePixelRatio || 1));
    const px = ZOOM_LADDER.find((s) => s >= need && s <= cap) || cap;
    return full.replace(/([?&])d=\d+x\d+/, '$1d=' + px + 'x' + px);
  };


  const fillMedia = (root, list, items, max) => {
    const tpl = root.querySelector('[data-mqle-media-chip]');
    if (!list || !tpl || !items || !items.length) return 0;
    const frag = document.createDocumentFragment();
    const extra = items.length - max;
    items.slice(0, max).forEach((item, i) => {
      const thumb = mediaUrl(item, THUMB_KEYS);
      if (!thumb) return;
      const node = tpl.content.firstElementChild.cloneNode(true);
      const btn = node.querySelector('[data-mqle-zoom]');
      const zoom = btn.querySelector('.mqle-media-chip__zoom');
      btn.dataset.fullFallback = mediaUrl(item, FULL_KEYS);
      btn.dataset.full = zoomUrl(btn.dataset.fullFallback);
      node.querySelector('img').src = thumb;
      if (i === max - 1 && extra > 0) {
        btn.classList.add('mqle-media-chip--more');
        zoom.textContent = fmt(root.dataset.mediaMore, extra);
      }
      frag.appendChild(node);
    });
    if (!frag.childNodes.length) return 0;
    list.appendChild(frag);
    list.hidden = false;
    return items.length;
  };

  const buildCard = (root, review) => {
    const node = root.querySelector('[data-mqle-review-card]').content.firstElementChild.cloneNode(true);
    const pick = (sel) => node.querySelector(sel);
    const reviewer = review.reviewer || {};

    pick('[data-name]').textContent = reviewer.displayName || '';
    if (reviewer.isVerified) pick('[data-verified]').hidden = false;

    const variant = pick('[data-variant]');
    if (review.productVariantName) {
      variant.textContent = review.productVariantName;
      variant.hidden = false;
    }

    const stars = node.querySelector('.rating-stars');
    if (stars) {
      const rating = Math.max(0, Math.min(5, Number(review.rating) || 0));
      stars.style.setProperty('--rating-percent', (rating / 5) * 100 + '%');
      stars.setAttribute('aria-label', (root.dataset.starLabel || '').replace('%R', rating));
    }

    /* Okendo bos basligi "5 Stars" diye doldurur: docs/assets/mqle-reviews.js.md (28 Agu 2026) */
    const titleEl = pick('[data-title]');
    const titleText = (review.title || '').trim();
    if (titleText && !/^[1-5]\s*(stars?|y[ıi]ld[ıi]z)$/i.test(titleText)) {
      titleEl.textContent = titleText;
    } else {
      titleEl.hidden = true;
    }
    pick('[data-body]').textContent = review.body || '';
    if (review.isRecommended) pick('[data-rec]').hidden = false;
    pick('[data-date]').textContent = monthYear(review.dateCreated);
    fillMedia(root, node.querySelector('[data-review-media]'), review.media, 3);

    return node;
  };

  const hydrate = (root) => {
    const data = readJSON(root);
    if (!data) return;

    fillSummary(root, data.reviewAggregate || {});


    /* Ust seviye media[] bos gelebiliyor; kaynak sirasi + tek istek: docs/assets/mqle-reviews.js.md (28 Agu 2026) */
    const mediaBox = root.querySelector('[data-mqle-media]');
    const rail = root.querySelector('[data-mqle-media-rail]');
    if (mediaBox && rail) {
      const agg = data.reviewAggregate || {};
      const collect = (reviews) => (reviews || []).reduce((acc, r) => acc.concat(r.media || []), []);
      const showRail = (items) => {
        const shown = fillMedia(root, rail, items, 8);
        mediaBox.hidden = !shown;
        const c = mediaBox.querySelector('[data-mqle-media-count]');
        if (c && shown) c.textContent = fmt(root.dataset.mediaCount, items.length);
      };
      const local = data.media && data.media.length ? data.media : collect(data.reviews);
      let href = '';
      if (local.length < Math.min(agg.mediaCount || 0, 8) && data.reviewsNextUrl) {
        try {
          const u = new URL(data.reviewsNextUrl);
          u.search = '?limit=8&orderBy=' + encodeURIComponent('has_media desc');
          href = u.href;
        } catch (e) {
          href = '';
        }
      }
      if (href) {
        fetch(href)
          .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
          .then((page) => showRail(collect(page.reviews)))
          .catch(() => showRail(local));
      } else {
        showRail(local);
      }
    }


    const dlg = root.querySelector('[data-mqle-dialog]');
    if (dlg && dlg.showModal) {
      const dimg = dlg.querySelector('[data-mqle-dialog-img]');
      root.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-mqle-zoom]');
        if (!btn || !btn.dataset.full) return;
        dimg.onerror = () => {
          dimg.onerror = null;
          const fb = btn.dataset.fullFallback;
          if (dlg.open && fb && fb !== btn.dataset.full) dimg.src = fb;
        };
        dimg.src = btn.dataset.full;
        dlg.showModal();
      });

      dlg.addEventListener('close', () => { dimg.src = ''; });
      dlg.addEventListener('click', (e) => {
        if (e.target === dlg || e.target.closest('[data-mqle-dialog-close]')) dlg.close();
      });
    }

    const list = root.querySelector('[data-mqle-review-list]');
    const more = root.querySelector('[data-mqle-review-more]');
    const size = Math.max(1, parseInt(root.dataset.pageSize, 10) || 5);

    const state = { seed: '', next: '', busy: false };

    const append = (reviews) => {
      const frag = document.createDocumentFragment();
      const oncekiSayi = list.children.length;
      reviews.slice(0, size).forEach((review) => frag.appendChild(buildCard(root, review)));
      list.appendChild(frag);
      const yeniKartlar = Array.prototype.slice.call(list.children, oncekiSayi);
      const olcVeIsaretle = () => {
        yeniKartlar.forEach((node) => {
          const body = node.querySelector('[data-body]');
          const clamp = node.querySelector('.mqle-review__clamp');
          if (!body || !clamp) return;
          clamp.classList.toggle('mqle-review__clamp--fits', body.scrollHeight <= body.clientHeight + 1);
        });
      };
      requestAnimationFrame(olcVeIsaretle);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(olcVeIsaretle);
    };

    append(data.reviews || []);

    state.next = data.reviewsNextUrl || data.nextUrl || '';
    state.seed = data.reviewsNextUrl || '';
    more.hidden = !state.next;

    more.addEventListener('click', () => {
      if (state.busy || !state.next) return;
      const href = absolutise(state.next, state.seed);
      if (!href) {
        state.next = '';
        more.hidden = true;
        return;
      }
      state.busy = true;
      more.disabled = true;

      const url = new URL(href);
      url.searchParams.set('limit', String(size));
      state.seed = url.href;

      fetch(url.href)
        .then((res) => (res.ok ? res.json() : Promise.reject(res.status)))
        .then((page) => {
          append(page.reviews || []);
          state.next = page.nextUrl || page.reviewsNextUrl || '';
        })

        .catch(() => {
          state.next = '';
        })
        .finally(() => {
          state.busy = false;
          more.disabled = false;
          more.hidden = !state.next;
        });
    });
  };

  const observe = (root) => {
    if (root.hasAttribute(READY)) return;
    root.setAttribute(READY, '');

    if (!('IntersectionObserver' in window)) {
      hydrate(root);
      return;
    }

    const io = new IntersectionObserver(
      (entries, self) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        self.disconnect();
        hydrate(root);
      },

      { rootMargin: '400px 0px' }
    );
    io.observe(root);
  };

  const scan = (scope) => (scope || document).querySelectorAll('[data-mqle-reviews]').forEach(observe);

  scan(document);

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
